import { useRef } from 'react';

const useChartImageDownload = () => {
  const chartRef = useRef(null);

  const downloadImage = (chartId) => {
    if (!chartRef.current) return;

    const tempCanvas = document.createElement('canvas');
    tempCanvas.width = chartRef.current.canvas.width;
    tempCanvas.height = chartRef.current.canvas.height;
    const tempCtx = tempCanvas.getContext('2d');

    tempCtx.fillStyle = 'white';
    tempCtx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);

    tempCtx.drawImage(chartRef.current.canvas, 0, 0);

    const image = tempCanvas.toDataURL('image/jpeg');

    const link = document.createElement('a');
    link.href = image;
    link.download = `${chartId}.jpg`;
    link.click();
  };

  return {chartRef, downloadImage };
};

export default useChartImageDownload;
